import lozad from 'lozad';

export default {
	init() {

		var container = document.querySelector('.archiveShop');

		if( container ) {

			function listenLinkToChange() {
				// funkcja jest uruchamiana w momęcie zmiany parametrow filtrowania

				var links = container.querySelectorAll('.linkToChange');

				links.forEach( function( link,index ) {

					if( link.classList.contains('searchform__link') ) { 
						// specialna funkcjonalność jeżeli użytkownik zaznaczył "Wyszukaj z zachowanie wybranych filtrów" to również zamień url w przycisku "Szukaj"

						if( document.querySelector('.switch__single--filter input').checked == true ) {

							link.setAttribute('href', generateNewUrl( link.getAttribute('data-url')) );							

						}

					} else if ( link.classList.contains('list__main') || link.classList.contains('list__child') ) {

						link.setAttribute('href', generateNewUrl(link.getAttribute('data-url') ) );

					} else {

						link.setAttribute('href', generateNewUrl( link.getAttribute('data-url')) );

					}

				});

			}

			function generateNewUrl( urlOrigin = null ) {
				// funkcja generująca nowy adres url na podstawie uzupełnionych parametrów

				if( !urlOrigin ) {

					urlOrigin = window.location.origin+window.location.pathname;

				}
					
				var urlArgs = [];
				var args = [
					'brand=' + main.getAttribute('data-brand'),
					'price_min=' + main.getAttribute('data-price_min'),
					'price_max=' + main.getAttribute('data-price_max'),
					'sort=' + main.getAttribute('data-sort'),
					'pnum=' + main.getAttribute('data-pnum'),
					's='+main.getAttribute('data-s'),
					'searchType='+main.getAttribute('data-searchType'),
				];	

				args.forEach( function(value,key) {

					if( value.split('=')[1] ) {

						urlArgs.push(value);

					}					

				});

				if( urlArgs.length > 0 ) {

					urlOrigin = urlOrigin+'?'+urlArgs.join('&');

				}

				return urlOrigin;

			}
			
			function changeBrowserHistory() {
				// funkcja dodająca do history zmianę filtrowania sortowania
				window.history.pushState('' ,main.getAttribute('data-title'), generateNewUrl() ); 

			}

			var xhr = new XMLHttpRequest();
			var xmlDoc = null;
			function reloadContent() {

				xhr = new XMLHttpRequest();
				xhr.onreadystatechange = function() {
					
					if( xhr.readyState == 4 && xhr.status == 200) {

            			var xmlDoc = document.implementation.createHTMLDocument("example");
						xmlDoc.documentElement.innerHTML = xhr.responseText;

						container.querySelectorAll('.container__content .content').forEach( function( box,index ) {

							box.remove();

						});

						xmlDoc.querySelectorAll('.container__content .content').forEach( function( box,index ) {

							container.querySelector('.container__content').insertBefore(box, container.querySelector('.container__content').lastChild.nextSibling );

						});

						var pictureObserverAfterLoadDOM = lozad('.lazy-load-item', {
			    			threshold: 0,
			    			loaded: function(el) {
			                    el.classList.add('asset-loaded');
			                }
						});
						pictureObserverAfterLoadDOM.observe();

						container.querySelector('.shop__container').classList.remove('shop__container--loaded');

        			} 

				}
				xhr.open( 'GET', generateNewUrl()+'&ajax=yes', true );
				xhr.send();

			}

			var main = document.querySelector('main');
			var timeout = null;
			var timeoutTime = 800;
			function changeAttributeValue( name, value ) {

				// -- cleanTimeout -- //

					clearTimeout( timeout );
					timeout = null;

				// -- END -- //


					main.setAttribute('data-'+name, value);


				// -- setTimeout -- //

					timeout = setTimeout(function() {

						main.querySelector('.shop__container').classList.add('shop__container--loaded');
						listenLinkToChange();
						changeBrowserHistory();
						reloadContent();

					}, timeoutTime);

				// -- END -- //

			}


			var hide = true;
			var cleanAllFilter = document.querySelector('.filters__clean');
			var searchFormSwitcher = document.querySelector('.header__switch');
			function checkToShowDisableFilter() {
				// funkcja sprawdza filtry ( cenę i markę pojazu i to co wpisane w szukajce )

				hide = true;
				container.querySelectorAll('.inputToChange').forEach( function(input, value) {

					if( input.name != 'searchType' && input.name != 'pnum' && input.name != 'sort') {

						if( input.type == 'radio' && input.checked == true ) {

							hide = false;

						} else if( input.type == 'number' && input.value ) {

							hide = false;

						}

					}						

				});

				if( hide ) {

					cleanAllFilter.classList.remove('show');
					searchFormSwitcher.classList.remove('show');

				} else {

					cleanAllFilter.classList.add('show');
					searchFormSwitcher.classList.add('show');

				}

			}


			function listenInputToChange() {

				function priceInputFunction( input ) {

					changeAttributeValue( input.getAttribute('name'), input.value );
					changeAttributeValue( 'pnum', 1 );

					if( input.value && !input.classList.contains('input--active') ) {

						input.closest('div.filters__single').querySelector('.row__clean').classList.add('show');
						input.classList.add('input--active');

					} else if( !input.value ) {

						input.closest('div.filters__single').querySelector('.row__clean').classList.remove('show');
						input.classList.remove('input--active');

					}

				}

				container.addEventListener('change', function(e) {

					if( e.target.classList.contains('inputToChange') ) {

						if( e.target.name == 'brand' ) {

							// -- remove active from radio -- //

								e.target.closest('.single__list').querySelectorAll('label.list__single').forEach( function(label, index2) {

									label.classList.remove('list__single--active');

								});

							// -- END -- //

							e.target.closest('div.filters__single').querySelector('.row__clean').classList.add('show');
							e.target.closest('label.list__single').classList.add('list__single--active');
							changeAttributeValue( e.target.getAttribute('name'), e.target.getAttribute('data-value') );
							changeAttributeValue( 'pnum', 1 );

						} else if( e.target.name == 'sort' ) {

							changeAttributeValue( e.target.getAttribute('name'), e.target.value );
							changeAttributeValue( 'pnum', 1 );

							document.querySelectorAll('select option').forEach( function( option, index ) {

								console.log(option);

								if( option.value == e.target.value ) {

									option.selected = true;

								} else {

									option.selected = false;									

								}

							});

						} 

						checkToShowDisableFilter();

					}

				});

				container.addEventListener('keyup', function(e) {

					if( e.target.classList.contains('inputToChange') ) {

						if( e.target.name == 'price_min' || e.target.name == 'price_max' ) {

							priceInputFunction( e.target );

						} else if ( e.target.name == 'pnum' ) {

							if( 
								e.target.value > parseInt( e.target.getAttribute('min') ) && 
								e.target.value <= parseInt( e.target.getAttribute('max') ) 
							) {

								changeAttributeValue( e.target.getAttribute('name'), e.target.value );

							} else {

								changeAttributeValue( e.target.getAttribute('name'), 1 );

							}

						}

						checkToShowDisableFilter();

					}

				});

				container.addEventListener('input', function(e) {

					if( e.target.classList.contains('inputToChange') ) {

						if( e.target.name == 'price_min' || e.target.name == 'price_max' ) {

							priceInputFunction(e.target);

						}

						checkToShowDisableFilter();

					}

				})

			}


			function cleanButtonFiltersBrand() {

				var filter = container.querySelector('.filters__single.filters__single--brand');
				var button = filter.querySelector('button.row__clean');

				button.addEventListener('click', function() {

					filter.querySelectorAll('.single__list .list__single ').forEach( function(label, index) {

						label.classList.remove('list__single--active');
						label.querySelector('input').checked = false;

					});

					changeAttributeValue('brand','');
					button.classList.remove('show');
					checkToShowDisableFilter();

				});

			}


			function cleanButtonFiltersPrice() {

				var filter = container.querySelector('.filters__single.filters__single--price');
				var button = filter.querySelector('button.row__clean');

				button.addEventListener('click', function() {

					filter.querySelectorAll('input').forEach( function(input,index) {

						input.classList.remove('input--active');
						input.value = '';

					});

					changeAttributeValue('price_min','');
					changeAttributeValue('price_max','');
					button.classList.remove('show');
					checkToShowDisableFilter();

				});

			}

			function searchFormSetUrl( url ) {
				// funkcja wywoływana jedynie przez funkcję searchFormSwitch()

				var searchLink = container.querySelector('.header__content .header__searchform .searchform__link');

				searchLink.setAttribute('href', url);

			}

			function searchFormSwitch() {

				var main = document.querySelector('main');

				var searchDiv = container.querySelector('.header__content .header__searchform');
				var searchSwitch = container.querySelectorAll('.header__switch .switch__single input');
				var searchInput = searchDiv.querySelector('.searchform__field');
				var searchLink = container.querySelector('.searchform__link');

				function searchInputAction() {

					main.setAttribute('data-s',searchInput.value);

					searchSwitch.forEach( function( input, index ) {

						if( input.checked == true && input.value == 'all' )  {

							searchFormSetUrl( searchDiv.getAttribute('data-mainUrl')+'?s='+searchInput.value );

						} else if( input.checked == true && input.value == 'withFilter' ) {

							main.setAttribute('data-pnum', 1);
							searchFormSetUrl( generateNewUrl() );

						}

					});

				}

				searchSwitch.forEach( function( input, index ) {

					input.addEventListener('change', function() {

						if( input.value == 'all' ) {

							main.setAttribute('data-searchType',input.value);
							searchFormSetUrl( searchDiv.getAttribute('data-mainUrl')+'?s='+searchInput.value );

						} else if( input.value == 'withFilter' ) {

							main.setAttribute('data-searchType',input.value);
							main.setAttribute('data-pnum', 1);
							searchFormSetUrl( generateNewUrl() );

						}

					});

				});

				searchInput.addEventListener('keyup', function() {
					searchInputAction();
				});

				searchInput.addEventListener('keypress', function(e) {
					
					if( e.key == 'Enter' ) {

						searchInputAction();
						searchLink.click();

					}

				});

			}

			function showMoreBrand() {

				var box = container.querySelector('.filters__single--brand');
				var hideItems = box.querySelectorAll('.list__single--hide');
				var showButton = box.querySelector('.list__more');

				if( hideItems ) {

					showButton.addEventListener('click', function() {

						hideItems.forEach( function(item,index) {

							item.classList.remove('list__single--hide');

						});

						showButton.classList.add('list__more--hide');

					});

				}

			}

			function openFiltersMobile() {

				var filters = container.querySelector('.shop__filters');
				var mask = document.querySelector('.archiveShop__filtersMask');

				container.addEventListener('click', function(e){

					if( e.target.classList.contains('left__filters') || e.target.closest('.left__filters') ) {

						filters.classList.add('open');
						mask.classList.add('active');

					};

				});

				mask.addEventListener('click', function() {

					filters.classList.remove('open');
					mask.classList.remove('active');

				});

			}

			showMoreBrand();
			listenInputToChange();
			cleanButtonFiltersBrand();
			cleanButtonFiltersPrice();
			searchFormSwitch();
			openFiltersMobile();

		}
    
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};
